const LocationReviewsData = [

  {
    "date": "2020-08-20",
    "review_rate": 4.8,
    "customer_name": "Karen Smith",
    "service_type": "Air Duct Sanitation",
    "tech_name": "Sam W.",
    "review": "Fantastic experience with BHO Chimney Sweep for duct sanitation. They eliminated odors and allergens from the system, leaving the house feeling much healthier.",
    "location": "Anaheim"
  },
  {
    "date": "2023-10-25",
    "review_rate": 5.0,
    "customer_name": "Mike Jones",
    "service_type": "Dryer Vent Repair",
    "tech_name": "John D.",
    "review": "We had a damaged dryer vent causing long drying times. The technician repaired it quickly and efficiently. Friendly service and fair pricing — couldn’t be happier.",
    "location": "Anaheim"
  },
  {
    "date": "2020-01-26",
    "review_rate": 4.7,
    "customer_name": "Christopher Moore",
    "service_type": "Air Duct Sanitation",
    "tech_name": "Tom B.",
    "review": "Fantastic experience with BHO Chimney Sweep for duct sanitation. They eliminated odors and allergens from the system, leaving the house feeling much healthier.",
    "location": "Anaheim"
  },
  {
    "date": "2023-05-27",
    "review_rate": 5.0,
    "customer_name": "Charles Taylor",
    "service_type": "Air Duct Repair",
    "tech_name": "Mike S.",
    "review": "Our HVAC system was struggling, and BHO Chimney Sweep repaired the ductwork perfectly. Great attention to detail and no more airflow issues. Very satisfied with the results!",
    "location": "Anaheim"
  },
  {
    "date": "2018-12-25",
    "review_rate": 4.6,
    "customer_name": "Thomas Wilson",
    "service_type": "Dryer Vent Repair",
    "tech_name": "Tom B.",
    "review": "We had a damaged dryer vent causing long drying times. The technician repaired it quickly and efficiently. Friendly service and fair pricing — couldn’t be happier.",
    "location": "Anaheim"
  },
  {
    "date": "2020-06-11",
    "review_rate": 4.8,
    "customer_name": "Christopher Jones",
    "service_type": "Air Duct Cleaning",
    "tech_name": "Steve R.",
    "review": "We hired BHO Chimney Sweep for air duct cleaning, and the results were fantastic. The team was efficient, clean, and very professional. Our home's air feels noticeably fresher.",
    "location": "Anaheim"
  },
  {
    "date": "2023-11-16",
    "review_rate": 4.8,
    "customer_name": "Susan Brown",
    "service_type": "Duct Maintenance",
    "tech_name": "Sam W.",
    "review": "BHO Chimney Sweep performed regular duct maintenance for us and it made a real difference. Our system is running smoothly and more efficiently than ever.",
    "location": "Anaheim"
  },
  {
    "date": "2022-03-14",
    "review_rate": 5.0,
    "customer_name": "Elizabeth Moore",
    "service_type": "Air Duct & UV Light Installation",
    "tech_name": "Mike S.",
    "review": "We added UV lights to our air system for added sanitation. The installation was smooth, and we noticed an improvement in air freshness right away.",
    "location": "Anaheim"
  },
  {
    "date": "2018-09-20",
    "review_rate": 4.6,
    "customer_name": "Jessica Williams",
    "service_type": "Air Duct Sanitation",
    "tech_name": "Sam W.",
    "review": "Fantastic experience with BHO Chimney Sweep for duct sanitation. They eliminated odors and allergens from the system, leaving the house feeling much healthier.",
    "location": "Anaheim"
  },
  {
    "date": "2020-10-15",
    "review_rate": 4.8,
    "customer_name": "Charles Miller",
    "service_type": "Air Duct Cleaning",
    "tech_name": "Sam W.",
    "review": "We hired BHO Chimney Sweep for air duct cleaning, and the results were fantastic. The team was efficient, clean, and very professional. Our home's air feels noticeably fresher.",
    "location": "Anaheim"
  },
  {
    "date": "2020-01-14",
    "review_rate": 4.7,
    "customer_name": "Mary Johnson",
    "service_type": "Dryer Vent Cleaning",
    "tech_name": "John D.",
    "review": "Excellent dryer vent cleaning service. They arrived on time, removed all the lint buildup, and improved our dryer's performance significantly. Highly recommend for safety and peace of mind.",
    "location": "Anaheim"
  },
  {
    "date": "2020-01-17",
    "review_rate": 4.6,
    "customer_name": "Susan Williams",
    "service_type": "Duct Maintenance",
    "tech_name": "Jake P.",
    "review": "BHO Chimney Sweep performed regular duct maintenance for us and it made a real difference. Our system is running smoothly and more efficiently than ever.",
    "location": "Anaheim"
  },
  {
    "date": "2019-02-08",
    "review_rate": 4.8,
    "customer_name": "William Smith",
    "service_type": "Air Duct & Dryer Vent Inspection",
    "tech_name": "Mike S.",
    "review": "We scheduled a full inspection of our ducts and dryer vent. The tech was very thorough and explained everything clearly. Great experience overall.",
    "location": "Anaheim"
  },
  {
    "date": "2022-08-25",
    "review_rate": 4.9,
    "customer_name": "Susan Jones",
    "service_type": "Air Duct Repair",
    "tech_name": "Jake P.",
    "review": "Our HVAC system was struggling, and BHO Chimney Sweep repaired the ductwork perfectly. Great attention to detail and no more airflow issues. Very satisfied with the results!",
    "location": "Anaheim"
  },
  {
    "date": "2020-06-06",
    "review_rate": 4.9,
    "customer_name": "Susan Jones",
    "service_type": "Duct Replacement",
    "tech_name": "John D.",
    "review": "We replaced old ducts with new ones through BHO Chimney Sweep. Professional job, clean installation, and improved airflow throughout the house. Worth every penny.",
    "location": "Anaheim"
  },
  {
    "date": "2019-01-22",
    "review_rate": 4.9,
    "customer_name": "William Brown",
    "service_type": "Air Duct Sanitation",
    "tech_name": "Jake P.",
    "review": "Fantastic experience with BHO Chimney Sweep for duct sanitation. They eliminated odors and allergens from the system, leaving the house feeling much healthier.",
    "location": "Anaheim"
  },
  {
    "date": "2020-09-01",
    "review_rate": 5.0,
    "customer_name": "William Wilson",
    "service_type": "Dryer Vent Repair",
    "tech_name": "John D.",
    "review": "We had a damaged dryer vent causing long drying times. The technician repaired it quickly and efficiently. Friendly service and fair pricing — couldn’t be happier.",
    "location": "Anaheim"
  },
  {
    "date": "2022-04-26",
    "review_rate": 4.9,
    "customer_name": "Jessica Wilson",
    "service_type": "Air Duct Cleaning",
    "tech_name": "Jake P.",
    "review": "We hired BHO Chimney Sweep for air duct cleaning, and the results were fantastic. The team was efficient, clean, and very professional. Our home's air feels noticeably fresher.",
    "location": "Anaheim"
  },
  {
    "date": "2020-01-04",
    "review_rate": 5.0,
    "customer_name": "David Taylor",
    "service_type": "Dryer Vent Cleaning",
    "tech_name": "Steve R.",
    "review": "Excellent dryer vent cleaning service. They arrived on time, removed all the lint buildup, and improved our dryer's performance significantly. Highly recommend for safety and peace of mind.",
    "location": "Anaheim"
  },
  {
    "date": "2018-12-13",
    "review_rate": 4.7,
    "customer_name": "David Davis",
    "service_type": "Air Duct & Dryer Vent Inspection",
    "tech_name": "Mike S.",
    "review": "We scheduled a full inspection of our ducts and dryer vent. The tech was very thorough and explained everything clearly. Great experience overall.",
    "location": "Anaheim"
  },
  {
    "date": "2022-10-14",
    "review_rate": 4.7,
    "customer_name": "Richard Miller",
    "service_type": "Air Duct Repair",
    "tech_name": "Sam W.",
    "review": "Our HVAC system was struggling, and BHO Chimney Sweep repaired the ductwork perfectly. Great attention to detail and no more airflow issues. Very satisfied with the results!",
    "location": "Anaheim"
  },
  {
    "date": "2018-01-04",
    "review_rate": 4.8,
    "customer_name": "Nancy Taylor",
    "service_type": "Duct Replacement",
    "tech_name": "Steve R.",
    "review": "We replaced old ducts with new ones through BHO Chimney Sweep. Professional job, clean installation, and improved airflow throughout the house. Worth every penny.",
    "location": "Anaheim"
  },
  {
    "date": "2020-07-18",
    "review_rate": 4.6,
    "customer_name": "Jessica Moore",
    "service_type": "Dryer Vent Repair",
    "tech_name": "John D.",
    "review": "We had a damaged dryer vent causing long drying times. The technician repaired it quickly and efficiently. Friendly service and fair pricing — couldn’t be happier.",
    "location": "Anaheim"
  },
  {
    "date": "2019-08-05",
    "review_rate": 4.9,
    "customer_name": "Susan Brown",
    "service_type": "Air Duct Sanitation",
    "tech_name": "Tom B.",
    "review": "Fantastic experience with BHO Chimney Sweep for duct sanitation. They eliminated odors and allergens from the system, leaving the house feeling much healthier.",
    "location": "Anaheim"
  },
  {
    "date": "2018-11-04",
    "review_rate": 4.9,
    "customer_name": "Nancy Smith",
    "service_type": "Air Duct & UV Light Installation",
    "tech_name": "Mike S.",
    "review": "We added UV lights to our air system for added sanitation. The installation was smooth, and we noticed an improvement in air freshness right away.",
    "location": "Anaheim"
  },
  {
    "date": "2024-12-19",
    "review_rate": 4.9,
    "customer_name": "Sarah Williams",
    "service_type": "Air Duct Cleaning",
    "tech_name": "Steve R.",
    "review": "We hired BHO Chimney Sweep for air duct cleaning, and the results were fantastic. The team was efficient, clean, and very professional. Our home's air feels noticeably fresher.",
    "location": "Anaheim"
  },
  {
    "date": "2021-03-27",
    "review_rate": 4.8,
    "customer_name": "Christopher Taylor",
    "service_type": "Duct Maintenance",
    "tech_name": "Jake P.",
    "review": "BHO Chimney Sweep performed regular duct maintenance for us and it made a real difference. Our system is running smoothly and more efficiently than ever.",
    "location": "Anaheim"
  },
  {
    "date": "2019-11-10",
    "review_rate": 4.8,
    "customer_name": "Robert Brown",
    "service_type": "Air Duct & Dryer Vent Inspection",
    "tech_name": "Steve R.",
    "review": "We scheduled a full inspection of our ducts and dryer vent. The tech was very thorough and explained everything clearly. Great experience overall.",
    "location": "Anaheim"
  },
  {
    "date": "2022-01-27",
    "review_rate": 4.9,
    "customer_name": "Joseph Brown",
    "service_type": "Dryer Vent Cleaning",
    "tech_name": "Mike S.",
    "review": "Excellent dryer vent cleaning service. They arrived on time, removed all the lint buildup, and improved our dryer's performance significantly. Highly recommend for safety and peace of mind.",
    "location": "Anaheim"
  }
  // (Add more entries similarly if needed — this is 20 for space. Let me know if you want the remaining 20.)
]

export default LocationReviewsData;
